import { defineMessages } from 'react-intl';

import { type TypeFilterValueKey } from '../../../../../common/constants/filters/universal-type';

export const typeLabels: Record<
	TypeFilterValueKey | 'all' | 'pageAndLiveDoc',
	import('react-intl').MessageDescriptor
> = defineMessages<TypeFilterValueKey | 'all' | 'pageAndLiveDoc'>({
	all: {
		id: 'search-page.filter.type.all',
		defaultMessage: 'All',
		description:
			'Drop-down item label for the All option in the content type filter, meaning no type filter is applied.',
	},
	position: {
		id: 'search-page.filter.type.position',
		defaultMessage: 'Positions',
		description:
			'Drop-down item label for Positions in the content type filter on the search page.',
	},
	document: {
		id: 'search-page.filter.type.documents',
		defaultMessage: 'Documents',
		description:
			'Drop-down item label for Documents in the content type filter on the search page.',
	},
	spreadsheet: {
		id: 'search-page.filter.type.spreadsheet',
		defaultMessage: 'Spreadsheets',
		description:
			'Drop-down item label for Spreadsheets in the content type filter on the search page.',
	},
	presentation: {
		id: 'search-page.filter.type.presentation',
		defaultMessage: 'Presentations',
		description:
			'Drop-down item label for Presentations in the content type filter on the search page.',
	},
	repository: {
		id: 'search-page.filter.type.repository',
		defaultMessage: 'Repositories',
		description:
			'Drop-down item label for Repositories in the content type filter on the search page.',
	},
	'pull-request': {
		id: 'search-page.filter.type.pull-request',
		defaultMessage: 'Pull requests',
		description:
			'Drop-down item label for Pull requests in the content type filter on the search page.',
	},
	branch: {
		id: 'search-page.filter.type.branch',
		defaultMessage: 'Branches',
		description: 'Drop-down item label for Branches in the content type filter on the search page.',
	},
	commit: {
		id: 'search-page.filter.type.commit',
		defaultMessage: 'Commits',
		description: 'Drop-down item label for Commits in the content type filter on the search page.',
	},
	conversation: {
		id: 'search-page.filter.type.conversation',
		defaultMessage: 'Channels',
		description:
			'Drop-down item label for Channels (conversations) in the content type filter on the search page.',
	},
	message: {
		id: 'search-page.filter.type.message',
		defaultMessage: 'Messages',
		description: 'Drop-down item label for Messages in the content type filter on the search page.',
	},
	video: {
		id: 'search-page.filter.type.video',
		defaultMessage: 'Videos',
		description: 'Drop-down item label for Videos in the content type filter on the search page.',
	},
	design: {
		id: 'search-page.filter.type.design',
		defaultMessage: 'Designs',
		description: 'Drop-down item label for Designs in the content type filter on the search page.',
	},
	pageAndLiveDoc: {
		id: 'search-page.filter.type.pageAndLiveDoc',
		defaultMessage: 'Pages and Live Docs',
		description:
			'Drop-down item label for the combined Pages and Live Docs option in the content type filter.',
	},
	page: {
		id: 'search-page.filter.type.page',
		defaultMessage: 'Pages',
		description:
			'Drop-down item label for Confluence Pages in the content type filter on the search page.',
	},
	blogpost: {
		id: 'search-page.filter.type.blogpost',
		defaultMessage: 'Blog posts',
		description:
			'Drop-down item label for Blog posts in the content type filter on the search page.',
	},
	attachment: {
		id: 'search-page.filter.type.attachment',
		defaultMessage: 'Attachments',
		description:
			'Drop-down item label for Attachments in the content type filter on the search page.',
	},
	space: {
		id: 'search-page.filter.type.space',
		defaultMessage: 'Spaces',
		description:
			'Drop-down item label for Confluence Spaces in the content type filter on the search page.',
	},
	whiteboard: {
		id: 'search-page.filter.type.whiteboard',
		defaultMessage: 'Whiteboards',
		description:
			'Drop-down item label for Whiteboards in the content type filter on the search page.',
	},
	slide: {
		id: 'search-page.filter.type.slide',
		defaultMessage: 'Slides',
		description: 'Drop-down item label for Slides in the content type filter on the search page.',
	},
	issue: {
		id: 'search-page.filter.type.jira-work-item',
		defaultMessage: 'Work items',
		description:
			'Drop-down item label for Jira work items in the content type filter on the search page.',
	},
	project: {
		id: 'search-page.filter.type.project',
		defaultMessage: 'Projects',
		description: 'Drop-down item label for Projects in the content type filter on the search page.',
	},
	goal: {
		id: 'search-page.filter.type.goal',
		defaultMessage: 'Goals',
		description: 'Drop-down item label for Goals in the content type filter on the search page.',
	},
	tag: {
		id: 'search-page.filter.type.tag',
		defaultMessage: 'Tags',
		description: 'Drop-down item label for Tags in the content type filter on the search page.',
	},
	'web-page': {
		id: 'search-page.filter.type.web-page',
		defaultMessage: 'Web pages',
		description:
			'Drop-down item label for Web pages in the content type filter on the search page.',
	},
	comment: {
		id: 'search-page.filter.type.comment',
		defaultMessage: 'Comments',
		description: 'Drop-down item label for Comments in the content type filter on the search page.',
	},
	database: {
		id: 'search-page.filter.type.database',
		defaultMessage: 'Databases',
		description:
			'Drop-down item label for Databases in the content type filter on the search page.',
	},
	embed: {
		id: 'search-page.filter.type.embed',
		defaultMessage: 'Smart Links',
		description:
			'Drop-down item label for Smart Links (embeds) in the content type filter on the search page.',
	},
	folder: {
		id: 'search-page.filter.type.folder',
		defaultMessage: 'Folders',
		description: 'Drop-down item label for Folders in the content type filter on the search page.',
	},
	calendar: {
		id: 'search-page.filter.type.calendar',
		defaultMessage: 'Calendars',
		description:
			'Drop-down item label for Calendars in the content type filter on the search page.',
	},
	'space-calendar': {
		id: 'search-page.filter.type.space-calendar',
		defaultMessage: 'Space calendars',
		description:
			'Drop-down item label for Space calendars in the content type filter on the search page.',
	},
	answer: {
		id: 'search-page.filter.type.answer',
		defaultMessage: 'Answers',
		description: 'Drop-down item label for Answers in the content type filter on the search page.',
	},
	question: {
		id: 'search-page.filter.type.question',
		defaultMessage: 'Questions',
		description:
			'Drop-down item label for Questions in the content type filter on the search page.',
	},
	component: {
		id: 'search-page.filter.type.component',
		defaultMessage: 'Components',
		description:
			'Drop-down item label for Components in the content type filter on the search page.',
	},
	'work-item': {
		id: 'search-page.filter.type.work-item',
		defaultMessage: 'Tasks',
		description:
			'Drop-down item label for Tasks (work items) in the content type filter on the search page.',
	},
	card: {
		id: 'search-page.filter.type.card',
		defaultMessage: 'Cards',
		description: 'Drop-down item label for Cards in the content type filter on the search page.',
	},
	incident: {
		id: 'search-page.filter.type.incident',
		defaultMessage: 'Incidents',
		description: 'Incident filter type for ServiceNow only',
	},
	'focus-area': {
		id: 'search-page.filter.type.focus-area',
		defaultMessage: 'Focus areas',
		description:
			'Drop-down item label for Focus areas in the content type filter on the search page.',
	},
	organization: {
		id: 'search-page.filter.type.organization',
		defaultMessage: 'Organizations',
		description:
			'Drop-down item label for Organizations in the content type filter on the search page.',
	},
	ask: {
		id: 'search-page.filter.type.ask',
		defaultMessage: 'Asks',
		description: 'Drop-down item label for Asks in the content type filter on the search page.',
	},
	risk: {
		id: 'search-page.filter.type.risk',
		defaultMessage: 'Risks',
		description: 'Drop-down item label for Risks in the content type filter on the search page.',
	},
	dashboard: {
		id: 'search-page.filter.type.dashboard',
		defaultMessage: 'Dashboards',
		description:
			'Drop-down item label for Dashboards in the content type filter on the search page.',
	},
	invoice: {
		id: 'search-page.filter.type.invoice',
		defaultMessage: 'Invoices',
		description: 'Drop-down item label for Invoices in the content type filter on the search page.',
	},
	deal: {
		id: 'search-page.filter.type.deal',
		defaultMessage: 'Deals',
		description: 'Drop-down item label for Deals in the content type filter on the search page.',
	},
	gliffy: {
		id: 'search-page.filter.type.gliffy',
		defaultMessage: 'Gliffy Diagrams',
		description:
			'Drop-down item label for Gliffy Diagrams in the content type filter on the search page.',
	},
	'customer-contact': {
		id: 'search-page.filter.type.customer-contact',
		defaultMessage: 'Customer Contacts',
		description:
			'Drop-down item label for Customer Contacts in the content type filter on the search page.',
	},
	'customer-org': {
		id: 'search-page.filter.type.customer-org',
		defaultMessage: 'Customer Organizations',
		description:
			'Drop-down item label for Customer Organizations in the content type filter on the search page.',
	},
	board: {
		id: 'search-page.filter.type.board',
		defaultMessage: 'Boards',
		description: 'Drop-down item label for Boards in the content type filter on the search page.',
	},
	plan: {
		id: 'search-page.filter.type.plan',
		defaultMessage: 'Plans',
		description: 'Drop-down item label for Plans in the content type filter on the search page.',
	},
	filter: {
		id: 'search-page.filter.type.filter',
		defaultMessage: 'Filters',
		description:
			'Drop-down item label for saved Filters in the content type filter on the search page.',
	},
	'data-table': {
		id: 'search-page.filter.type.data-table',
		defaultMessage: 'Data tables',
		description:
			'Drop-down item label for Data tables in the content type filter on the search page.',
	},
	object: {
		id: 'search-page.filter.type.object',
		defaultMessage: 'Objects',
		description:
			'Drop-down item label for Assets Objects in the content type filter on the search page.',
	},
	schema: {
		id: 'search-page.filter.type.schema',
		defaultMessage: 'Schemas',
		description:
			'Drop-down item label for Assets Schemas in the content type filter on the search page.',
	},
	type: {
		id: 'search-page.filter.type.type',
		defaultMessage: 'Object types',
		description:
			'Drop-down item label for Assets Object types in the content type filter on the search page.',
	},
	epic: {
		id: 'search-page.filter.type.epic',
		defaultMessage: 'Epic',
		description:
			'Drop-down item label for the Epic work type in the content type filter on the search page.',
	},
	bug: {
		id: 'search-page.filter.type.bug',
		defaultMessage: 'Bug',
		description:
			'Drop-down item label for the Bug work type in the content type filter on the search page.',
	},
	story: {
		id: 'search-page.filter.type.Story',
		defaultMessage: 'Story',
		description:
			'Drop-down item label for the Story work type in the content type filter on the search page.',
	},
	task: {
		id: 'search-page.filter.type.task',
		defaultMessage: 'Task',
		description:
			'Drop-down item label for the Task work type in the content type filter on the search page.',
	},
	subtask: {
		id: 'search-page.filter.type.subtask',
		defaultMessage: 'Subtask',
		description:
			'Drop-down item label for the Subtask work type in the content type filter on the search page.',
	},
	image: {
		id: 'search-page.filter.type.image',
		defaultMessage: 'Images',
		description: 'Drop-down item label for Images in the content type filter on the search page.',
	},
	audio: {
		id: 'search-page.filter.type.audio',
		defaultMessage: 'Audio',
		description:
			'Drop-down item label for Audio files in the content type filter on the search page.',
	},
	pdf: {
		id: 'search-page.filter.type.pdf',
		defaultMessage: 'PDF',
		description:
			'Drop-down item label for PDF files in the content type filter on the search page.',
	},
	shortcut: {
		id: 'search-page.filter.type.shortcut',
		defaultMessage: 'Shortcut',
		description:
			'Drop-down item label for Shortcuts in the content type filter on the search page.',
	},
	code: {
		id: 'search-page.filter.type.code',
		defaultMessage: 'Code',
		description:
			'Drop-down item label for Code files in the content type filter on the search page.',
	},
	archive: {
		id: 'search-page.filter.type.archive',
		defaultMessage: 'Archive',
		description:
			'Drop-down item label for Archive files in the content type filter on the search page.',
	},
	form: {
		id: 'search-page.filter.type.form',
		defaultMessage: 'Form',
		description: 'Drop-down item label for Forms in the content type filter on the search page.',
	},
	notebook: {
		id: 'search-page.filter.type.notebook',
		defaultMessage: 'Notebook',
		description:
			'Drop-down item label for Notebooks in the content type filter on the search page.',
	},
	other: {
		id: 'search-page.filter.type.other',
		defaultMessage: 'Other',
		description:
			'Drop-down item label for miscellaneous uncategorized content in the type filter on the search page.',
	},
	article: {
		id: 'search-page.filter.type.article',
		defaultMessage: 'Articles',
		description: 'Drop-down item label for Articles in the content type filter on the search page.',
	},
	post: {
		id: 'search-page.filter.type.post',
		defaultMessage: 'Posts',
		description: 'Drop-down item label for Posts in the content type filter on the search page.',
	},
	ticket: {
		id: 'search-page.filter.type.ticket',
		defaultMessage: 'Tickets',
		description: 'Drop-down item label for Tickets in the content type filter on the search page.',
	},
	'devops-work-item': {
		id: 'search-page.filter.type.devops-work-item',
		defaultMessage: 'Issues',
		description:
			'Drop-down item label for DevOps Issues in the content type filter on the search page.',
	},
	campaign: {
		id: 'search-page.filter.type.campaign',
		defaultMessage: 'Campaigns',
		description:
			'Drop-down item label for Campaigns in the content type filter on the search page.',
	},
	case: {
		id: 'search-page.filter.type.case',
		defaultMessage: 'Cases',
		description: 'Drop-down item label for Cases in the content type filter on the search page.',
	},
	'catalog-item': {
		id: 'search-page.filter.type.catalog-item',
		defaultMessage: 'Catalog items',
		description: 'Catalog item filter type for ServiceNow only',
	},
	'requested-item': {
		id: 'search-page.filter.type.requested-item',
		defaultMessage: 'Requested items',
		description: 'Requested item filter type for ServiceNow only',
	},
	'knowledge-article': {
		id: 'search-page.filter.type.knowledge-article',
		defaultMessage: 'Knowledge articles',
		description: 'Knowledge article filter type for ServiceNow only',
	},
	'news-article': {
		id: 'search-page.filter.type.news-article',
		defaultMessage: 'News articles',
		description: 'News article filter type for ServiceNow only',
	},
	demand: {
		id: 'search-page.filter.type.demand',
		defaultMessage: 'Demands',
		description: 'Demand filter type for ServiceNow only',
	},
	lead: {
		id: 'search-page.filter.type.lead',
		defaultMessage: 'Leads',
		description: 'Lead filter type for Salesforce only',
	},
});
